import { getUpsellingLensPackages } from "./getUpsellingLensPackages";

if (window) {
  window.rxcCartTool = {
    getUpsellingLensPackages,
  };
}
